import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 3a3 3 0 0 1 2.995 2.824L22 6v1h5a1 1 0 0 1 .116 1.993L27 9h-1v18a2 2 0 0 1-1.85 1.994L24 29H8a2 2 0 0 1-1.995-1.85L6 27V9H5a1 1 0 0 1-.117-1.993L5 7h5V6a3 3 0 0 1 2.824-2.995L13 3zm5 6H8v18h16zm-10.007 4.883A1 1 0 0 0 12 14v8l.007.117A1 1 0 0 0 14 22v-8zM19 13a1 1 0 0 1 .993.883L20 14v8a1 1 0 0 1-1.993.117L18 22v-8a1 1 0 0 1 1-1m-6-8h6l.117.007A1 1 0 0 1 20 6v1h-8V6l.007-.117A1 1 0 0 1 13 5"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconTrash = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTrash);
export default Memo;
